import React from "react";
import styled from "styled-components";
import FormButtons from "src/components/CreditRatingForm/FormButtons";
import { StepControls } from "src/components/CreditRatingStepWizard/CreditRatingStepWizard";
import Gauge from "src/components/icons/Gauge";

const Root = styled("div")`
    align-items: center;
    display: flex;
    flex-direction: column;
    justify-content: center;

    .SoftCreditPullForm--section.SoftCreditPullForm--buttons {
        flex-direction: column;
    }
`;

const Description = styled("div")`
    color: ${(props) => props.theme.palette.grey[80]};
    font-size: 14px;
    margin-top: 13px;
`;

interface CreditRatingInitialProps {
    CTA: string;
    description: string;
}

const CreditRatingInitial = ({ next, CTA, description }: StepControls & CreditRatingInitialProps) => {
    return (
        <Root>
            <FormButtons showCancel={false} onSubmit={next} continueText={CTA} continueIcon={<Gauge />} />
            <Description>{description}</Description>
        </Root>
    );
};

export default CreditRatingInitial;
